module.exports = __webpack_public_path__ + "static/media/25_tn.18646323.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/25_tn.jpg
// module id = 513
// module chunks = 0